import './style.less';
import * as React from 'react';
import { Spinner } from 'telstra-ui/components/spinner/spinner';
import { Button } from 'telstra-ui/components/button/Button';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const serverErrorLarge = require('../../images/Server-Error-Large.svg');

interface IPageLoadingIndicatorProps {
    error: boolean;
}

export class PageLoadingIndicator extends React.PureComponent<IPageLoadingIndicatorProps> {
    constructor(props) {
        super(props);
    }

    public render() {
        const { error } = this.props;
        if (error) {
            return this.renderPageLoadError();
        }
        return this.renderPageLoadingIndicator();
    }

    private renderPageLoadError = () => {
        return (
            <div className="tc-im">
                <div className="tc-im-page-loader">
                    <div className="tc-im-page-loader__container">
                        <div className="tc-im-page-loader__container__img">
                            <img src={serverErrorLarge} />
                        </div>
                        <span className="tc-im-page-loader__container__text">
                            Failed to load the requested resource
                        </span>
                        <div className="tc-im-page-loader__container__try-again">
                            <Button
                                label="Try again"
                                onClick={this.tryAgain}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderPageLoadingIndicator = () => {
        return (
            <div className="tc-im">
                <div className="tc-im-page-loader">
                    <div className="tc-im-page-loader__container">
                        <Spinner size="tl-spinner-xlarge" />
                    </div>
                </div>
            </div>
        );
    }

    private tryAgain = () => {
        return window.location.reload();
    }
}
